/**
 * Ek mesai talebinin doluluğu (QR Mesai Faz 2, 18.10.2026; simülasyondaki kutular ve rozetle aynı).
 * ■ yerleşen · ■ (mor) isimle ayrılıp henüz gelmeyen · □ boş.
 */

export type DolulukKutusu = 'yerlesen' | 'ayrilan' | 'bos';

export interface DolulukGirdisi {
    kisiSayisi: number
    yerlesenSayisi: number
    /** İsimle ayrılan personel; geldi = o kişi talebe yerleşti. */
    ayrilanlar?: { geldi: boolean }[] | null
}

export interface Doluluk {
    kutular: DolulukKutusu[]
    /** İstenen − yerleşen (en az 0). */
    eksik: number
    /** Ayrılıp henüz gelmeyen kişi sayısı. */
    bekleyenAyrilan: number
    rozet: { metin: string, ton: 'basari' | 'uyari' | 'tehlike' }
}

const tamSayi = (n: number | null | undefined) => Math.max(0, Math.floor(Number(n) || 0));

/**
 * Kutular ve rozet. Planlanan talepte eksik varsa "N kişi eksik" (uyarı), yoksa "Doldu";
 * tamamlanan talepte "yerleşen/istenen kişi" (eksikse tehlike rengi).
 */
export const talepDolulugu = (t: DolulukGirdisi, tamamlandi: boolean = false): Doluluk => {
    var kisi = tamSayi(t.kisiSayisi);
    var yerlesen = tamSayi(t.yerlesenSayisi);
    var bekleyenAyrilan = (t.ayrilanlar ?? []).filter(x => !x.geldi).length;
    var eksik = Math.max(0, kisi - yerlesen);

    var kutular: DolulukKutusu[] = [];

    for (var i = 0; i < kisi; i++)
        kutular.push(i < yerlesen ? 'yerlesen' : i < yerlesen + bekleyenAyrilan ? 'ayrilan' : 'bos');

    var rozet: Doluluk['rozet'] = tamamlandi
        ? { metin: `${Math.min(yerlesen, kisi)}/${kisi} kişi`, ton: eksik > 0 ? 'tehlike' : 'basari' }
        : eksik > 0
            ? { metin: `${eksik} kişi eksik`, ton: 'uyari' }
            : { metin: 'Doldu', ton: 'basari' };

    return { kutular, eksik, bekleyenAyrilan, rozet };
}

/** Durum adı (sunucunun durum kodundan). */
export const talepDurumAdi = (durum: string | undefined) =>
    durum == 'ONAY_BEKLIYOR' ? 'Onay Bekliyor' : durum == 'REVIZE' ? 'Revize' : durum == 'BEKLIYOR' ? 'Mesai Bekliyor' : durum == 'TAMAMLANAN' ? 'Tamamlanan' : 'Planlanan';

/** Durum rozetinin rengi. */
export const talepDurumRengi = (durum: string | undefined) =>
    durum == 'REVIZE' ? 'badge-light-danger' : durum == 'ONAY_BEKLIYOR' ? 'badge-light-info' : durum == 'BEKLIYOR' ? 'badge-light-warning' : durum == 'TAMAMLANAN' ? 'badge-light-success' : 'badge-light-primary';
